import { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../../context/UserContext";
import { SettingOption } from "../../../components/SettingOption/setting-option";
import "./developer-settings.css";
import warningIcon from "../../../assets/images/warning.png";
import { NotificationsContext } from "../../../context/NotificationsContext";
import { UpdateSetting } from "../../../utils/httpUtils";
import { Log } from "../../../utils/genericUtils";

const defaultProps = {
  developer_mode: true,
  setting2: true,
  setting3: true,
};

export default function DeveloperSettings(props = defaultProps) {
  useEffect(() => {}, []);

  const { user, loginUser } = useContext(UserContext);
  const { pushNotification } = useContext(NotificationsContext);

  const valid = useRef(new Map());

  const [developerMode, setEnableDeveloperMode] = useState(props.developer_mode);

  // const [enableStorageCapacityNotifications, setEnableStorageCapacityNotifications] = useState(props.setting2);
  // const [enablePaymentNotifications, setEnablePaymentNotfications] = useState(props.setting3);

  function EnableDeveloperMode(enabled) {
    setEnableDeveloperMode(enabled);
    UpdateSetting("developer_mode", enabled, user).then((response) => {
      if (response.success) {
        let message = enabled ? "Developer Mode enabled" : "Developer mode disabled";
        pushNotification("Setting Updated", message);
      } else {
        setEnableDeveloperMode(!enabled);
        pushNotification("Setting Failed To Update", (response.error && response.error.message) ?? "Unknown error occured");
      }
    });
  }

  return (
    <section className="developer-settings-container">
      <SettingOption
        id={"developer-mode"}
        controlType={"toggle"}
        defaultValue={developerMode}
        onChange={(value) => EnableDeveloperMode(value)}
        description={developerMode ? "Disable Developer Mode" : "Enable Developer Mode"}
        // only confirm for disable mfa
        useConfirmation={developerMode === true ? true : false}
        confirmationSettings={{
          id: "developer-toggle",
          icon: warningIcon,
          header: "Are you sure you want to disable developer mode?",
          message: "doing so will revoke any existing api key",
          confirmText: "disable developer mode",
          denyText: "keep developer mode enabled",
          denyClass: "btn-green",
        }}
      />


      {/* Settings Enabled When Developer Mode === True */}
      {developerMode === true && (
        <>
          <h3>Actions</h3>
          <div className="setting-option-divider"></div>
          <SettingOption
            id={"revoke-api-keys"}
            controlType={"button"}
            buttonText="Revoke Api Keys"
            buttonClass={"btn-red-inverted"}
            description="Invalidate all active api keys"
            onClick={() => Log("TO DO: ", "revoke api keys endpoint")}
            showDivider={false}
          />
        </>
      )}
    </section>
  );
}
